export function hasChangedFormValues(values, baselineValues) {
  const fieldNames = new Set([
    ...Object.keys(values || {}),
    ...Object.keys(baselineValues || {}),
  ]);

  return Array.from(fieldNames).some(
    (fieldName) => normalizeFormValue(values?.[fieldName]) !== normalizeFormValue(baselineValues?.[fieldName])
  );
}

function normalizeFormValue(value) {
  if (value === null || typeof value === 'undefined') {
    return '';
  }

  if (typeof value === 'object') {
    return JSON.stringify(value);
  }

  return String(value);
}
